import { Component, Input, OnChanges, SimpleChanges, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import * as L from 'leaflet';
import { GeocodingService } from '../../services/geocoding.service';

@Component({
    selector: 'app-map-view',
    templateUrl: './map-viewer.html',
    styleUrls: ['./map-viewer.scss'],
    standalone: false
})
export class MapViewerComponent implements OnChanges, AfterViewInit {

  @Input() latitude!: number;
  @Input() longitude!: number;
  /** Valgfri adresse — geokodes (med caching) når koordinater mangler. */
  @Input() address?: string;

  @ViewChild('mapEl', { static: true }) mapEl!: ElementRef<HTMLElement>;

  private map!: L.Map;
  private marker!: L.Marker;
  leafletOptions: L.MapOptions;

  constructor(private geocoding: GeocodingService) {
    this.leafletOptions = {
      layers: [
        L.tileLayer('https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/{z}/{y}/{x}.png', { attribution: '&copy; <a href="http://www.kartverket.no/">Kartverket</a>' })
      ],
      zoom: 15,
      center: L.latLng(0, 0)
    };
  }

  ngAfterViewInit() {
    this.initializeMap();
    this.resolveAndShow();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.map && (changes.latitude || changes.longitude || changes.address)) {
      this.resolveAndShow();
    }
  }

  private initializeMap() {
    if (!this.map) {
      // Bruk selve elementet (ViewChild) i stedet for en hardkodet id="map",
      // slik at flere kart kan vises samtidig (f.eks. i ordrelista).
      this.map = L.map(this.mapEl.nativeElement, this.leafletOptions);
      setTimeout(() => this.map.invalidateSize(), 100);
    }
  }

  private resolveAndShow() {
    if (this.hasValidCoords(this.latitude, this.longitude)) {
      this.setLocation(this.latitude, this.longitude);
    } else if (this.address && this.address.trim()) {
      this.geocoding.geocode(this.address.trim()).then((point) => {
        if (point) {
          this.setLocation(point.lat, point.lng);
        }
      });
    }
  }

  private hasValidCoords(lat: number, lng: number): boolean {
    return !!lat && !!lng && lat !== 0 && lng !== 0 && !isNaN(lat) && !isNaN(lng);
  }

  private setLocation(lat: number, lng: number) {
    if (!this.map) { return; }
    this.map.setView([lat, lng], 15);
    this.addMarker(lat, lng);
    setTimeout(() => this.map.invalidateSize(), 50);
  }

  private addMarker(lat: number, lng: number) {
    const customIcon = L.icon({
      iconUrl: 'assets/icon/marker-icon.png',
      shadowUrl: 'assets/icon/marker-shadow.png',
      iconSize: [30, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });

    if (this.marker) {
      this.marker.setLatLng([lat, lng]);
    } else {
      this.marker = L.marker([lat, lng], { icon: customIcon }).addTo(this.map);
    }
  }
}
